import React from "react";
import {Head} from "@inertiajs/react";
import classNames from "classnames";
import useWithStore from "@/Hooks/useWithStore";
import useBodyClass from "@/Hooks/useBodyClass";
import useDeleteLoader from "@/Hooks/Effects/useDeleteLoader";
import useGlobalUserActivity from "@/Hooks/Effects/GlobalListeners/useGlobalUserActivity";
import useGlobalUserDataLayer from "@/Hooks/Effects/Analytics/useGlobalUserDataLayer";
import usePageChangesForYaMetrica from "@/Hooks/Effects/Analytics/usePageChangesForYaMetrica";
import useCloseModalWindows from "@/Hooks/Effects/Modals/useCloseModalWindows";
import useShowWheelOfFortune from "@/Hooks/Effects/Modals/useShowWheelOfFortune";
import useShowContinueApplication from "@/Hooks/Effects/Modals/useShowContinueApplication";
import useShowDiscountOnFirstOrder from "@/Hooks/Effects/Modals/useShowDiscountOnFirstOrder";
import useShowGiftCalendar from "@/Hooks/Effects/Modals/useShowGiftCalendar";
import useShowSecretSanta from "@/Hooks/Effects/Modals/useShowSecretSanta";
import useBasketProductsUpdate from "@/Hooks/Effects/Stores/useBasketProductsUpdate";
import useFavouritesDataChange from "@/Hooks/Effects/Stores/useFavouritesDataChange";
import usePressPopstateButton from "@/Hooks/Effects/Navigations/usePressPopstateButton";
import usePopstateButton from "@/Hooks/Effects/GlobalListeners/usePopstateButton";
import useFatalError from "@/Hooks/Effects/Errors/useFatalError";
import {useScrollDirection} from "@/features/header";
import {Button} from "@/shared/ui/Button";
import {Svg} from "@/shared/ui/Svg";
import {Header} from "@/widgets/header";
import {Footer} from "@/widgets/footer";
import {MobileNavBar} from "@/widgets/mobile-nav-bar";
import ModalWindows from "@/Components/Site/ModalWindows";
import styles from "@/app/layouts/baseLayout.module.scss";

const BaseLayout = (props) => {
    const {children, title = "", description = "", pathCanonical = "", robots = ""} = props;

    const {scrollY} = useScrollDirection();

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name={`description`} content={description} />
                <link rel={`canonical`} href={pathCanonical} />
                <meta name={`robots`} content={robots} />
            </Head>
            <div id={`site`} className={styles.siteContainer}>
                <Effects {...props} />
                <Header {...props} />
                <section className={styles.section}>
                    {children}
                </section>
                <Footer {...props} />
                <MobileNavBar
                    isAuthenticated={props.isAuthenticated}
                    hideMobileNavBar={props.hideMobileNavBar}
                    user={props.user}
                />
            </div>
            <Button
                className={classNames(styles.backToTop, {[styles.visible]: scrollY > 112})}
                onClick={() => window.scrollTo(0, 0)}
            >
                <Svg id={`arrowUp`} className={styles.arrowBackToTop} />
            </Button>
            <ModalWindows {...props} />
        </>
    );
}

const Effects = (props) => {
    /**
     * Добавляем слушатели на события пользователя
     */
    useGlobalUserActivity();

    /**
     * Чтобы важные изменения страницы фиксировались Яндекс Метрикой
     */
    usePageChangesForYaMetrica();

    /**
     * Если 500 ошибка
     */
    useFatalError(props);

    /**
     * Событие нажатий кнопок «Назад» или «Вперёд»
     */
    usePopstateButton();

    /**
     * Отправка user id в dataLayer (Задача № 5895)
     */
    useGlobalUserDataLayer(props);

    // /**
    //  * Определение местоположения по IP-Адресу (Через сервис DaData)
    //  */
    // useDetectLocation();

    /**
     * Закрытие модальных окон
     */
    useCloseModalWindows(props);

    /**
     * Показываем окно с колесом фортуны
     */
    useShowWheelOfFortune(props);

    /**
     * Модальное окно "Продолжить в приложении"
     */
    useShowContinueApplication(props);

    /**
     * Модальное окно "Скидка на первый заказ"
     */
    useShowDiscountOnFirstOrder(props);

    /**
     * Модальное окно "Весенний календарь подарков"
     */
    useShowGiftCalendar(props);

    /**
     * Модальное окно "Тайный санта"
     */
    useShowSecretSanta(props);

    /**
     * Нажатие кнопок вперед/назад
     */
    usePressPopstateButton();

    /**
     * обновление состояния товаров корзины
     */
    useBasketProductsUpdate(props);

    /**
     * обновление состояния товаров избранного
     */
    useFavouritesDataChange(props);

    /**
     * Удаление элемента с id "loader"
     */
    useDeleteLoader();

    /**
     * Добавляем класс для тега body
     */
    useBodyClass();

    return null;
}

export default useWithStore(BaseLayout);
